import { render, staticRenderFns } from "./CasePayments.vue?vue&type=template&id=5f6260f2&"
import script from "./CasePayments.vue?vue&type=script&lang=js&"
export * from "./CasePayments.vue?vue&type=script&lang=js&"
import style0 from "./CasePayments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports